import { BoardValue } from '../../jscaip/AI/BoardValue';
import { Heuristic } from '../../jscaip/AI/Heuristic';
import { TeekoRules } from './TeekoRules';
export class TeekoHeuristic extends Heuristic {
    getBoardValue(node, _config) {
        const alignmentPossibilities = TeekoRules.TEEKO_HELPER.getBoardValue(node.gameState).metrics[0];
        const squarePossibilities = TeekoRules.get().getSquareInfo(node.gameState);
        return BoardValue.of(squarePossibilities.score + alignmentPossibilities);
    }
}
